import {Col, Row} from "react-simple-flex-grid";
import {useNavigate} from "react-router-dom";

export const TechnologiesContacts = () => {

    const navigate = useNavigate();

    return <>
        <Row>
            <Col span={12}>
                <div className="inspired-enough-block" onClick={() => navigate('/contact-us')}>
                    <h5>LET’S CREATE THE FUTURE TOGETHER</h5>
                    <div className="join-us-link">
                      Reach out
                        <svg xmlns="http://www.w3.org/2000/svg" width="51" height="50" viewBox="0 0 51 50" fill="none">
                            <path d="M0 2H49M49 2V48M49 2L4 48" stroke="#FDEEEE" strokeWidth="4"/>
                        </svg>
                    </div>
                </div>
            </Col>
        </Row>
    </>
}